import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDashboardStats as fetchDashboardStatsApi } from "../../services/apiConfig";

interface PoolNumberEntry {
  country: string;
  count: number;
}

interface DashboardState {
  stats: {
    total_users: number;
    available_sims: number;
    sold_today: number;
    last_users: any[];
    last_orders: any[];
    is_wl_admin?: boolean;
    pool_esims_available?: number;
    pool_numbers_available?: PoolNumberEntry[];
    brand_number_ownership?: any[];
  };
  loading: "idle" | "pending" | "succeeded" | "failed";
  error: string | null;
}

const initialState: DashboardState = {
  stats: {
    total_users: 0,
    available_sims: 0,
    sold_today: 0,
    last_users: [],
    last_orders: [],
  },
  loading: "idle",
  error: null,
};

export const fetchDashboardStats = createAsyncThunk(
  "dashboard/fetchDashboardStats",
  async () => {
    const response = await fetchDashboardStatsApi();
    return response;
  },
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.stats = action.payload;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message ?? "Failed to fetch dashboard stats";
      });
  },
});

export default dashboardSlice.reducer;
